import React, { useEffect, useCallback } from 'react'
import './QRCodeDialog.scss'
import { Grid, Dialog, IconButton, DialogTitle, DialogContent } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { QRCodeCanvas } from 'qrcode.react'
import { BiDownload } from 'react-icons/bi'

function QRCodeDialog({
  title,
  qrcodeContent,
  open,
  handleClose,
  qrCodeUrl,
  setQrCodeImage,
  setSendQrImage
}) {
  const b64toBlob = useCallback((b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: contentType })
    return blob
  }, [])
  const downloadQR = () => {
    const canvas = document.getElementById('qr')
    const pngUrl = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream')
    let downloadLink = document.createElement('a')
    downloadLink.href = pngUrl
    downloadLink.download = 'EntityQR.jpg'
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }
  useEffect(() => {
    if (open.qrCodeOpen && !qrCodeUrl) {
      console.log('qr dialog', qrcodeContent)
      console.log(open)
      setTimeout(() => {
        const canvas = document.getElementById('qr')
        let pngUrl = canvas.toDataURL('image/jpeg')
        pngUrl = pngUrl.replace('data:image/jpeg;base64,', '')
        const blob = b64toBlob(pngUrl.replace(/\s/g, ''), 'image/jpeg')
        setQrCodeImage(blob)
        setSendQrImage(false)
      }, 1000)
    }
  }, [open, qrCodeUrl, qrcodeContent, setQrCodeImage, setSendQrImage, b64toBlob])

  return (
    <div>
      <Dialog
        open={open.qrCodeOpen}
        className="online-dialog"
        id="qr-container"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="online-dialog-title">
          <span id="qrdialog-dialog">{title}</span>
          <IconButton
            aria-label="close"
            className="close-button"
            id="qr-close"
            onClick={() => handleClose({ ...open, qrCodeOpen: false })}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="online-dialog-content" id="qr-dialog-content">
          <Grid container>
            <div className="qrcode-container">
              <label className="qr-instruction" id="instruction">
                Give this QR code to your community members so they can find you easily after they
                have downloaded the MYLS app onto their device.
              </label>
              <QRCodeCanvas value={qrcodeContent} size={150} id="qr" />
            </div>
          </Grid>
          <Grid size={12} className="container container-palette" id="download-conatiner">
            <button id="qrcode-a" onClick={downloadQR} type="button">
              DOWNLOAD
            </button>
            <BiDownload color="#1c9cd5" id="bi-icon" />
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default QRCodeDialog
